import React from 'react';
import { motion } from 'framer-motion';
import unidadeLucianoCavalcante from '../assets/images/unidade_luciano_cavalcante.jpeg';
import unidadeMessejana from '../assets/images/unidade_messejana.png';

const Unidades: React.FC = () => {
  // Animação para elementos que aparecem ao rolar
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  // Lista de unidades
  const unidades = [
    { 
      id: 'luciano-cavalcante', 
      nome: 'Luciano Cavalcante', 
      endereco: 'Rua Esperança, 56 – Luciano Cavalcante',
      cep: 'CEP 60.811-243',
      telefone: '(85) 3055-1414',
      whatsapp: '(85) 99240-5667',
      horarios: {
        segunda: '06:00 às 22:00',
        terca: '06:00 às 22:00',
        quarta: '06:00 às 22:00',
        quinta: '06:00 às 22:00',
        sexta: '06:00 às 22:00',
        sabado: '08:00 às 14:00',
        domingo: 'Fechado'
      },
      imagem: unidadeLucianoCavalcante,
      mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3307335777097!2d-38.4945!3d-3.7745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM8KwNDYnMjguMiJTIDM4wrAyOSczNy4yIlc!5e0!3m2!1spt-BR!2sbr!4v1622824567890!5m2!1spt-BR!2sbr'
    },
    { 
      id: 'messejana', 
      nome: 'Messejana', 
      endereco: 'Rua Chico França, 720 – Messejana',
      cep: 'CEP 60.871-100',
      telefone: '(85) 3055-1414',
      whatsapp: '(85) 99240-5667',
      horarios: {
        segunda: '06:00 às 22:00',
        terca: '06:00 às 22:00',
        quarta: '06:00 às 22:00',
        quinta: '06:00 às 22:00',
        sexta: '06:00 às 22:00',
        sabado: '08:00 às 14:00',
        domingo: 'Fechado'
      },
      imagem: unidadeMessejana,
      mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.1234567890123!2d-38.5123!3d-3.8345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM8KwNTAnMDQuMiJTIDM4wrAzMCc0NC4zIlc!5e0!3m2!1spt-BR!2sbr!4v1622824567890!5m2!1spt-BR!2sbr'
    }
  ];

  return (
    <div className="pt-24 pb-20">
      <div className="container mx-auto px-4">
        {/* Header da página */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Nossas <span className="text-primary">Unidades</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A TopSpinFit está presente em dois locais estratégicos de Fortaleza para melhor atender você.
            Conheça nossas unidades e escolha a mais próxima de você.
          </p>
        </motion.div>

        {/* Unidades */}
        {unidades.map((unidade, index) => (
          <motion.section
            key={unidade.id}
            id={unidade.id}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className={`mb-20 ${index % 2 === 1 ? 'bg-gray-100' : ''} py-12 rounded-lg`}
          >
            <div className="container mx-auto px-4">
              <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div>
                  <h2 className="text-3xl font-bold mb-4">
                    Unidade <span className="text-primary">{unidade.nome}</span>
                  </h2>
                  
                  <div className="mb-6">
                    <h3 className="text-xl font-semibold mb-2">Endereço</h3>
                    <p className="text-gray-700 flex items-start">
                      <svg className="w-5 h-5 mr-2 mt-1 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <span>
                        {unidade.endereco}
                        <br />
                        {unidade.cep}
                      </span>
                    </p>
                  </div>
                  
                  <div className="mb-6">
                    <h3 className="text-xl font-semibold mb-2">Contato</h3>
                    <p className="text-gray-700 flex items-center mb-2">
                      <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      {unidade.telefone}
                    </p>
                    <p className="text-gray-700 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                      </svg>
                      {unidade.whatsapp}
                    </p>
                  </div>
                  
                  <div className="mb-6">
                    <h3 className="text-xl font-semibold mb-2">Horários de Funcionamento</h3>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <div className="grid grid-cols-2 gap-2">
                        <div className="text-gray-700">Segunda-feira:</div>
                        <div className="font-medium">{unidade.horarios.segunda}</div>
                        
                        <div className="text-gray-700">Terça-feira:</div>
                        <div className="font-medium">{unidade.horarios.terca}</div>
                        
                        <div className="text-gray-700">Quarta-feira:</div>
                        <div className="font-medium">{unidade.horarios.quarta}</div>
                        
                        <div className="text-gray-700">Quinta-feira:</div>
                        <div className="font-medium">{unidade.horarios.quinta}</div>
                        
                        <div className="text-gray-700">Sexta-feira:</div>
                        <div className="font-medium">{unidade.horarios.sexta}</div>
                        
                        <div className="text-gray-700">Sábado:</div>
                        <div className="font-medium">{unidade.horarios.sabado}</div>
                        
                        <div className="text-gray-700">Domingo:</div>
                        <div className="font-medium">{unidade.horarios.domingo}</div>
                      </div>
                    </div>
                  </div>
                  
                  <button className="btn btn-primary">
                    Agendar Visita
                  </button>
                </div>
                
                <div className="space-y-6">
                  <div className="rounded-lg overflow-hidden shadow-lg">
                    <img 
                      src={unidade.imagem} 
                      alt={`Unidade ${unidade.nome}`} 
                      className="w-full h-auto"
                    />
                  </div>
                  
                  <div className="rounded-lg overflow-hidden shadow-lg h-64">
                    <iframe 
                      src={unidade.mapa} 
                      width="100%" 
                      height="100%" 
                      style={{ border: 0 }} 
                      allowFullScreen 
                      loading="lazy"
                      title={`Mapa da unidade ${unidade.nome}`}
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>
        ))}

        {/* CTA */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="mt-8 bg-secondary text-white p-8 md:p-12 rounded-lg text-center"
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Venha conhecer nossas unidades
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Agende uma visita e conheça nossa estrutura, equipamentos e metodologia de treino.
          </p>
          <button className="btn btn-primary text-lg">
            Agendar Visita Gratuita
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default Unidades;
